import { render } from "./Public.vue?vue&type=template&id=f71f05c0"
import script from "./Public.vue?vue&type=script&lang=js"
export * from "./Public.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/emporiobienessas.com/dashboard-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__